/** Small helpers shared by the Artwork health tabs. */

const CLOUDFLOW_HOST = 'wave.abaris.com.au';

/** ProofScope deep-link for a Cloudflow path, so you can eyeball the file. */
export function proofScopeUrl(path: string): string {
  return `https://${CLOUDFLOW_HOST}/portal.cgi?proofscope&url=${encodeURIComponent(path)}&topbar=true`;
}

export function fmtDateTime(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-AU', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

export function fmtDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: '2-digit' });
}

export function apiErr(e: unknown): string {
  const r = (e as { response?: { data?: { error?: string } } })?.response?.data?.error;
  return r || (e as Error)?.message || 'Request failed';
}
